export default "/images/vendor/flag-icons/flags/4x3/hr.svg?9211a54119b21828c73b0ec19efab3c3";